/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { Http, Response } from '@angular/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';
import { SFAnnouncement } from '../../models/SFAnnouncement';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `SFAnnouncement` model.
 */
@Injectable()
export class SFAnnouncementApi extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, searchParams, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} subjectEn 
   *
   * @param {String} detailEn 
   *
   * @param {String} fileName 
   *
   * @param {object} req 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFAnnouncement` object.)
   * </em>
   */
  public addAnnouncement(subjectEn: any, detailEn: any, fileName: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFAnnouncements/addAnnouncement";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof subjectEn !== 'undefined' && subjectEn !== null) _urlParams.subjectEn = subjectEn;
    if (typeof detailEn !== 'undefined' && detailEn !== null) _urlParams.detailEn = detailEn;
    if (typeof fileName !== 'undefined' && fileName !== null) _urlParams.fileName = fileName;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} announcementCode 
   *
   * @param {String} subjectName 
   *
   * @param {String} detailName 
   *
   * @param {String} fileName 
   *
   * @param {object} req 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFAnnouncement` object.)
   * </em>
   */
  public updateAnnouncement(announcementCode: any, subjectName: any, detailName: any, fileName: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFAnnouncements/updateAnnouncement";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof announcementCode !== 'undefined' && announcementCode !== null) _urlParams.announcementCode = announcementCode;
    if (typeof subjectName !== 'undefined' && subjectName !== null) _urlParams.subjectName = subjectName;
    if (typeof detailName !== 'undefined' && detailName !== null) _urlParams.detailName = detailName;
    if (typeof fileName !== 'undefined' && fileName !== null) _urlParams.fileName = fileName;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} announcementCode 
   *
   * @param {String} lang 
   *
   * @param {object} req 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFAnnouncement` object.)
   * </em>
   */
  public getAnnouncement(announcementCode: any = {}, lang: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFAnnouncements/getAnnouncement";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof announcementCode !== 'undefined' && announcementCode !== null) _urlParams.announcementCode = announcementCode;
    if (typeof lang !== 'undefined' && lang !== null) _urlParams.lang = lang;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} announcementCode 
   *
   * @param {object} req 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFAnnouncement` object.)
   * </em>
   */
  public delAnnouncement(announcementCode: any, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFAnnouncements/delAnnouncement";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof announcementCode !== 'undefined' && announcementCode !== null) _urlParams.announcementCode = announcementCode;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAnnouncement`.
   */
  public getModelName() {
    return "SFAnnouncement";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/SFAnnouncement.ts